<template>
    <div class="top-menu-upgrade" v-if="!hasPremium">
        <slot>
            <a :href="url" :target="isExternal() ? '_blank' : '_self'">
                <Crown class="crown-img" :baseData="baseData" />
                {{name}}
            </a>
        </slot>
    </div>
</template>

<script>
import Crown from '@root/lk/create/CreateChallenge/Crown.vue';

export default {
    props: ["name", "icon", "url", "crown", "baseData",],
    components: {
        Crown,
    },
    mounted() {
    },
    computed: {
        hasPremium() {
            const user = this.baseData?.viewingUser;
            if (!user) return false;
            if (!user.permissions) return false;
            if (!user.permissions.activePlans) return false;
            return user.permissions.activePlans.length > 0;
        },
    },
    methods: {
        isExternal() {
            const url = this.url;
            if (!url) return false;
            return url.indexOf("http") >= 0;
        },
    }
}
</script>

<style lang="scss" scoped>
    .top-menu-upgrade {
        padding-left: 16px;
        &:hover {
            opacity: 0.8;
        }
        a {
            position: relative;
            text-decoration: none;
            color: #FFC107;
            font-weight: 600;
        
        }
    }

</style>

<i18n>
{
    en: {
    },
    ru: {
    }
}
</i18n>
